import { WithSequenceStatePropsType } from 'components/hoc/withSequenceState';
import withSequenceState from 'components/hoc/withSequenceState';
import { CardProps } from 'components/molecules/Card';
import CardDetailRecipe from 'components/molecules/Card/Detail/Recipe';
import { CardDetailPropsType } from 'components/molecules/Card/Fragments/CardDetail';
import Sequences from 'defs/sequences';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators as optionalProgramItemsAC } from 'store/optionalProgramItems';
import {
	actionCreators,
	getKcalFromSelectedContent,
	getNutritionFromSelectedContent,
	getTotalDurationFormattedFromSelectedContent,
	getTotalDurationFromSelectedContent,
	RootStateType,
} from 'store/programItems';
import { actionCreators as transientPoolAC } from 'store/transientPoolState';

export type StateToPropsType = CardDetailPropsType & {
	title: CardProps['title'];
	energy: ReturnType<typeof getKcalFromSelectedContent>;
	totalDuration: ReturnType<typeof getTotalDurationFromSelectedContent>;
	totalDurationFormatted: ReturnType<typeof getTotalDurationFormattedFromSelectedContent>;
	isDone: boolean;
	nutrition: ReturnType<typeof getNutritionFromSelectedContent>;
	parentProps: any;
};

export type DispatchToPropsType = typeof actionCreators;

const mapStateToProps = (state: RootStateType, ownProps: CardDetailPropsType): StateToPropsType => {
	const selectedContent = ownProps.parentProps;

	return {
		...ownProps,
		title: selectedContent.title,
		energy: getKcalFromSelectedContent(selectedContent as any),
		totalDuration: getTotalDurationFromSelectedContent(selectedContent as any),
		totalDurationFormatted: getTotalDurationFormattedFromSelectedContent(selectedContent as any),
		isDone: false,
		nutrition: getNutritionFromSelectedContent(selectedContent as any),
	};
};

const mapDispatchToProps = (dispatch): DispatchToPropsType => {
	return bindActionCreators(
		{
			...actionCreators,
			doSetProgramItemRef: transientPoolAC.doSetProgramItemRef,
			doCreateItem: optionalProgramItemsAC.doCreateItem,
		},
		dispatch
	);
};

export type ContainerCardDetailRecipeFavoritePropsType = CardDetailPropsType &
	StateToPropsType &
	DispatchToPropsType &
	WithSequenceStatePropsType;

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withSequenceState(CardDetailRecipe, [Sequences.CARD_IS_CHECKING]) as any);
